import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { PaneService } from 'src/app/services/pane.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[asgPaneIndex]',
    standalone: true
})
export class PaneIndexDirective implements AfterViewInit, OnDestroy {
  @Input() paneIndex: number | null = null;

  private readonly subscriptions = new Subscription();
  private currentActivePaneIndex: number | null = 0;

  constructor(
    private paneService: PaneService,
    private el: ElementRef,
  ) { }

  ngAfterViewInit() {
    this.addClickListenerAndSubscriptions();
  }

  ngOnDestroy() {
    this.el.nativeElement.removeEventListener('click', this.clickHandler, true);
    this.subscriptions.unsubscribe();
  }

  private addClickListenerAndSubscriptions() {
    this.el.nativeElement.addEventListener('click', this.clickHandler, true);
    this.subscriptions.add(
      this.paneService.getActivePaneObservable().subscribe(e => {
      this.currentActivePaneIndex = e;
    }));
  }

  private clickHandler = async () => {
    if (this.paneIndex !== null) {
      if (this.paneIndex !== this.currentActivePaneIndex) {
      }
      this.paneService.setActivePaneIndex(this.paneIndex);
    }
  }

}
